module.exports = __webpack_public_path__ + "static/media/curved.d22363c2.svg";